var _style, _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadshot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 502 503",
    style: {
      enableBackground: "new 0 0 502 503"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000048494492568482799020000013327373902002788788_);}\n\t.st1{fill:#C5C5C5;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 20,
    y: 23.8,
    width: 458.5,
    height: 458.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000146484549061704138110000008874106437659228321_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    style: {
      clipPath: "url(#SVGID_00000146484549061704138110000008874106437659228321_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    className: "st1",
    d: "M104.4,430.8c98.1,80,242.5,65.3,322.5-32.8s65.3-242.5-32.8-322.5S151.6,10.1,71.6,108.2 C38.2,149.1,20,200.3,20,253.1C20,322,51,387.2,104.4,430.8 M249.2,44.8c115,0,208.3,93.3,208.3,208.3 c0,60.4-26.2,117.8-71.8,157.3c-10.8-48-67.8-84.5-136.5-84.5s-125.7,36.6-136.5,84.5C25.9,335,16.5,203.5,91.9,116.6 C131.5,71,188.9,44.8,249.2,44.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    className: "st1",
    d: "M214.1,299.1c40,19.4,88.2,2.8,107.6-37.2c19.4-40,2.8-88.2-37.2-107.6 c-40-19.4-88.2-2.8-107.6,37.2c-5.3,11-8.1,23-8.1,35.2C168.6,257.5,186.3,285.7,214.1,299.1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadshot);
export default __webpack_public_path__ + "static/media/headshot.0cd930f46f0aeba7e4230e45945d18a0.svg";
export { ForwardRef as ReactComponent };